module.exports = __webpack_public_path__ + "static/media/background3.7f825f0c.png";